// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"MessagePage_wrapper__jXFnY","title":"MessagePage_title__Jb8TC","returnLink":"MessagePage_returnLink__GlbVl"};